import { BrowserCompatibility } from "./browserCompatibility";
import { CustomError } from "./customError";

export class UnsupportedBrowserError extends CustomError {
  public readonly data?: BrowserCompatibility;

  // istanbul ignore next
  constructor(browserCompatibility: BrowserCompatibility) {
    super({
      name: "UnsupportedBrowserError",
      message: "This OS / Browser has one or more missing features preventing it from working correctly",
    });
    this.data = browserCompatibility;
  }
}
